// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"e0325da7","422":"99404f71"}[chunkId] + ".chunk.js";
};